import { Textarea, TextInput } from "@mantine/core";
import React from "react";
import { withTranslation } from "react-i18next";

import "./styles.css";

const DescriptionFiled = ({
  label,
  value,
  disabled,
  width = "85%",
  icon,
  type = "text",
  placeholder,
  style,
  onChange,
  autoComplete = "off",
  form,
  validateName,
  required,
  onBlur,
  onInput,
  autosize,
  maxRows,
  minRows,
}) => {
  return (
    <Textarea
      styles={{
        input: {
          border: "1px solid #e0e0e0",
        },
      }}
      maxLength={1000}
      autosize={autosize}
      minRows={minRows}
      maxRows={maxRows}
      label={label}
      onChange={onChange}
      onInput={onInput}
      type={type}
      defaultValue={value}
      onBlur={onBlur}
      disabled={disabled}
      autoComplete={autoComplete}
      required={required}
      placeholder={placeholder}
      {...form?.getInputProps(validateName)}
    />
  );
};

export default withTranslation()(DescriptionFiled);
